import { type FC, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getCustomerPacksSummary, transformToCardReportingItems } from "../queries/useCustomerPacksSummaryQuery";
import { useCustomerPacksQuery } from "../queries/useCustomerPacksQuery";
import { RequestStatusRenderer } from "../../../../components/requestStatsRenderer/RequestStatusRenderer";
import { CustomerPackReportList } from "./CustomerPackReportList";
import CardReporting from "../../../../components/cards/CardReporting/CardReporting";
import styles from "./customerPackReport.module.scss";
import "features/Library/Common/utils/performanceSCSSUtils.scss";
import { type AccountType } from "interfaces/Account";
import { connect, type ConnectedProps } from "react-redux";
import { type AppDispatch, type RootState } from "../../../Application/globaltypes/redux";
import { dateRangeAllTime } from "features/Library/Common/utils/performanceUtils";
import DetailsHeader from "components/sectionHeader/detailsHeader/OutstandingDetailsHeader";
import cn from "classnames";

export type CustomerPackReportType = {
  type: AccountType | undefined;
};

export const CustomerPackReport: FC<PropsFromRedux> = ({ accountId }) => {
  const filter = dateRangeAllTime();

  const customerPacksSummaryQuery = useQuery({
    queryFn: getCustomerPacksSummary,
    queryKey: ["customerPacksSummary", accountId, filter],
    enabled: !!accountId,
  });

  const customerPacksQuery = useCustomerPacksQuery(accountId, filter);

  const customerCardsFormattedData = useMemo(() => {
    if (customerPacksSummaryQuery.data) {
      return transformToCardReportingItems(customerPacksSummaryQuery.data);
    }
    return [];
  }, [customerPacksSummaryQuery.data]);

  return (
    <div className={cn("performanceRoot", styles.root)}>
      <DetailsHeader title="Packs & Licensing" showReportLastUpdated />
      <div className={styles.scrollable}>
        <div className="performanceHeader">
          <h2 className="performanceTitle">Summary</h2>
        </div>
        <RequestStatusRenderer state={customerPacksSummaryQuery.status}>
          <CardReporting items={customerCardsFormattedData} />
        </RequestStatusRenderer>
        <RequestStatusRenderer state={customerPacksQuery.status}>
          <CustomerPackReportList customerPackData={customerPacksQuery.data || []} />
        </RequestStatusRenderer>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  accountId: state.userProfile.accountId,
});

const mapDispatchToProps = (_dispatch: AppDispatch) => ({});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(CustomerPackReport);
export default ConnectedComponent;
